// extracted by mini-css-extract-plugin
module.exports = {"EmailId":"MailAuditData_EmailId__1P9FR","audititem":"MailAuditData_audititem__pKHQa"};